import { HeadingProps } from "@atoms/Heading/utils/types";

/**
 * Returns the appropriate heading tag based on the provided level
 */
export const getHeadingTag = ({
  level,
}: Pick<HeadingProps, "level">): keyof JSX.IntrinsicElements => {
  return `h${level}` as keyof JSX.IntrinsicElements;
};

/**
 * Returns the appropriate heading class based on the provided level
 */
export const getHeadingExtraClass = ({
  level,
}: Pick<HeadingProps, "level">): string => {
  switch (level) {
    case 2:
    case 3:
    case 4:
    case 6:
      return "-tracking-5%";

    default:
      return "";
  }
};
